var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ScoreIcon',{attrs:{"title":`${
    _vm.acceptability !== null
      ? `${_vm.pluralize('{count} {argument:count}', {
          count: _vm.items.length,
        })} - ${_vm.acceptability * 100}% pro`
      : ''
  }`,"alternative":_vm.alternative,"icon":_vm.icon,"score":_vm.acceptability}})
}
var staticRenderFns = []

export { render, staticRenderFns }